/* import __COLOCATED_TEMPLATE__ from './add-ach-setup.hbs'; */
import { action } from '@ember/object';
import { bannerError } from 'client-portal/utils/error-handling';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class SiteBillingAddAchSetup extends Component {
  @service stripeAch;
  @service clientPortalTracking;
  @service intl;

  get actionsDisabled() {
    return this.stripeAch.addAchPaymentMethodTask.isRunning || Boolean(this.args.disableActions);
  }

  @action
  async addStripeAchPaymentMethod(elements) {
    try {
      let savedAchAccount = await this.stripeAch.addAchPaymentMethodTask.perform({
        elements,
        newAchAccount: this.args.model,
      });

      if (!savedAchAccount) {
        return;
      }

      await this.args.onSuccess?.(savedAchAccount);
    } catch (err) {
      let errorTitle = this.intl.t('billing.paymentMethods.achAddError');
      this.clientPortalTracking.trackErrorOnBillingPage(errorTitle);
      bannerError(err, { title: errorTitle });
    }
  }
}
